import { render, staticRenderFns } from "./DocumentsWidget.vue?vue&type=template&id=a24506e0&"
import script from "./DocumentsWidget.vue?vue&type=script&lang=js&"
export * from "./DocumentsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports